import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { ModalConfirmationService } from "./confirmation-modal/confirmation-modal.service";
import { ModalConfirmationComponent } from "./confirmation-modal/confirmation-modal.component";
import { InsurgoUIComponents } from "../../insurgo-ui-components/uiComponents.module";

import { ViewCompanyService } from "./viewCompany/viewCompany.service";
import { ViewCompanyModalComponent } from "./viewCompany/viewCompany.component";

import { ViewAddressService } from "./viewAddress/viewAddress.service";
import { ViewAddressModalComponent } from "./viewAddress/viewAddress.component";

import { AddUserService } from "./addUser/addUser.service";
import { AddUserModalComponent } from "./addUser/addUser.component";

import { BasicInputModalComponent } from "./basic-input-modal/basic-input-modal.component";
import { GenericInputService } from "./basic-input-modal/basic-input-modal.service";

import { MainPipeModule } from "../../insurgo-ui-components/pipes/pipes-module";
import { AgGridModule } from "ag-grid-angular";

import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbIconModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbUserModule,
  NbTabsetModule,
  NbFormFieldModule,
} from "@nebular/theme";

import { NgSelectModule } from "@ng-select/ng-select";

import { ThemeModule } from "../../@theme/theme.module";
import { ViewSingleTapeAnalysisService } from "./view-single-tape-analysis/view-single-tape-analysis.service";
import { ViewSingleTapeAnalysisComponent } from "./view-single-tape-analysis/view-single-tape-analysis.component";
import { CreateSalesOrderModalComponent } from "./create-sales-order/create-sales-order.component";
import { CreateSalesOrderService } from "./create-sales-order/create-sales-order.service";
import { OverrideTapeForSaleComponent } from "./override-tape-for-sale/override-tape-for-sale.component";
import { CreateSalesOrderBatchModalComponent } from "./create-sales-order-batch/create-sales-order-batch.component";
import { CreateSalesOrderBatchService } from "./create-sales-order-batch/create-sales-order-batch.service";

@NgModule({
    imports: [
        FormsModule,
        NbActionsModule,
        NbButtonModule,
        NbCardModule,
        NbCheckboxModule,
        NbDatepickerModule,
        NbIconModule,
        NbInputModule,
        NbRadioModule,
        NbSelectModule,
        NbUserModule,
        NbTabsetModule,
        ThemeModule,
        NgSelectModule,
        NbFormFieldModule,
        MainPipeModule,
        AgGridModule,
        CommonModule,
        InsurgoUIComponents,
    ],
    declarations: [
        ViewCompanyModalComponent,
        ViewAddressModalComponent,
        ModalConfirmationComponent,
        AddUserModalComponent,
        BasicInputModalComponent,
        ViewSingleTapeAnalysisComponent,
        CreateSalesOrderModalComponent,
        CreateSalesOrderBatchModalComponent,
        OverrideTapeForSaleComponent,
    ],
    providers: [
        ViewCompanyService,
        ModalConfirmationService,
        ViewAddressService,
        AddUserService,
        CreateSalesOrderService,
        CreateSalesOrderBatchService,
        GenericInputService,
        ViewSingleTapeAnalysisService,
    ]
})
export class ModalServiceModule {}
